import * as zod from 'zod';

import { HardwareConfigEquipmentMapping } from '@sb/ai/types';

import { Conditional } from '../../types';

export default zod.object({
  gpuTaskRunnerId: zod.string(),
  modelPath: zod.string(),
  timeout: zod.number(),
  secondaryRobotId: zod.string().nullable(),
  isBimanual: zod.boolean(),
  isPrimary: zod.boolean(),
  equipmentKeyToEquipmentId: zod.record(zod.string()).default({}),
  hardwareConfigEquipmentMapping: HardwareConfigEquipmentMapping.default({}),
  condition: Conditional.nullable(),
});
